import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import sharedMessages from "../../../../shared-messages";
import { Password as NewPasswordField } from "../../shared/fields";

const CoppaResetPasswordFormFields = ({ username }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <NewPasswordField
        username={username}
        label={formatMessage(sharedMessages.newPassword)}
        id="new-password"
        name="newPassword"
      />
    </>
  );
};

CoppaResetPasswordFormFields.propTypes = {
  username: PropTypes.string.isRequired
};

export default CoppaResetPasswordFormFields;
